import React, { useState, useEffect } from 'react'
import HoursModal from './HoursModal'
import { cloneDeep } from 'lodash'

export default function HoursInput(props) {
  const [HoursModalOpen, ModalOpenUpdater] = useState(false)
  const [editingDay, editingDayUpdater] = useState(null)

  const [daysTimeBlocks, daysTimeBlocksUpdater] = useState([
    {
      day: 'monday',
      timeBlocks: [
        // {
        //   open: '9:00 am',
        //   close: '18:00 am',
        //   isOpen: false,
        //   label: 'Normal Hours',
        //   isClosed: false,
        // },
        // {
        //   open: '9:00',
        //   close: '18:00',
        //   isOpen: false,
        //   label: 'Normal Hours',
        //   isClosed: false,
        // },
      ],
    },
    { day: 'tuesday', timeBlocks: [] },
    { day: 'wednesday', timeBlocks: [] },
    { day: 'thursday', timeBlocks: [] },
    { day: 'friday', timeBlocks: [] },
    { day: 'saturday', timeBlocks: [] },
    { day: 'sunday', timeBlocks: [] },
  ])

  useEffect(() => {
    props.updateHours(daysTimeBlocks)
    return () => {}
  })

  // open the hours modal
  const toggleModal = day => {
    editingDayUpdater(day)
    ModalOpenUpdater(!HoursModalOpen)
  }

  const daysOfWeek = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ]

  // finds the day of the week object from an array and the day parameter
  const findDayObjectIndex = (array, day) => {
    return array.findIndex(dayObject => dayObject.day === day)
  }

  // updates the timeblock for the day and time
  const updateStateHours = (day, timeBlockIndex, updates) => {
    // uses lodash to create a deep clone breaking any reference to the previous state
    const clonedState = cloneDeep(daysTimeBlocks)

    // updates the cloned object
    clonedState[findDayObjectIndex(clonedState, day)].timeBlocks[
      timeBlockIndex
    ] = updates

    // re writes over old state with new cloned state with updates.
    daysTimeBlocksUpdater(clonedState)
  }

  // removes the timeblock for the given parameters
  const removeTimeblockHours = (day, timeBlockIndex) => {
    // uses lodash to create a deep clone breaking any reference to the previous state
    const clonedState = cloneDeep(daysTimeBlocks)

    if (timeBlockIndex > -1) {
      clonedState[findDayObjectIndex(clonedState, day)].timeBlocks.splice(
        timeBlockIndex,
        1
      )
    }
    // re writes over old state with new cloned state with updates.
    daysTimeBlocksUpdater(clonedState)
  }

  const createNewTimeblock = day => {
    const defaultTimeBlock = {
      open: '9:00:00',
      close: '18:00:00',
      isOpen: false,
      label: '',
      isClosed: false,
    }

    updateStateHours(
      day,
      daysTimeBlocks[findDayObjectIndex(daysTimeBlocks, day)].timeBlocks.length,
      defaultTimeBlock
    )
  }

  const useForAllDays = timeBlocks => {
    const clonedState = cloneDeep(daysTimeBlocks)
    clonedState.forEach(day => {
      day.timeBlocks = timeBlocks
    })
    daysTimeBlocksUpdater(clonedState)
  }

  // load the days of the week or the modal editting the day.

  return (
    <div className='addhours-container'>
      {HoursModalOpen ? (
        <HoursModal
          toggleModal={toggleModal}
          editingDay={editingDay}
          daysTimeBlocks={daysTimeBlocks}
          updateStateHours={updateStateHours}
          createNewTimeblock={createNewTimeblock}
          removeTimeblockHours={removeTimeblockHours}
          useForAllDays={useForAllDays}
        />
      ) : (
        <div className='hours-daysofweek'>
          {daysOfWeek.map(day => (
            <div
              key={day}
              onClick={() => {
                toggleModal(day)
              }}>
              {day}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/Components/HoursInput/HoursInput.js